(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-camera-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('farmstream-custom-features')) {
    customElements.define('farmstream-custom-features', class extends HTMLElement {
      connectedCallback() {
        if (this.customFeaturesReady) return;
        this.customFeaturesReady = true;
        const tabs = [...this.querySelectorAll('[data-custom-tab]')];
        const video = this.querySelector('[data-river-video]');
        const streamStatus = this.querySelector('[data-stream-status]');
        const streamMessage = this.querySelector('[data-stream-message]');
        const retry = this.querySelector('[data-stream-retry]');
        const loadingMessage = streamMessage?.textContent;
        let streamLoaded = false;
        let streamLoading = false;
        const failStream = () => {
          clearTimeout(this.streamMediaTimeout);
          streamLoaded = false;
          streamStatus.hidden = false;
          streamMessage.textContent = this.dataset.streamError;
          retry.hidden = false;
        };
        const loadStream = async () => {
          if (!video || streamLoaded || streamLoading) return;
          streamLoading = true;
          streamStatus.hidden = false;
          streamMessage.textContent = loadingMessage;
          retry.hidden = true;
          this.streamController = new AbortController();
          const timeout = setTimeout(() => this.streamController.abort(), 12000);
          try {
            const response = await fetch(video.dataset.streamEndpoint, { signal: this.streamController.signal, cache: 'no-store' });
            if (!response.ok) throw new Error('Video unavailable');
            const url = new URL((await response.text()).trim());
            if (url.protocol !== 'https:') throw new Error('Invalid video URL');
            video.src = url.href;
            video.preload = 'metadata';
            video.load();
            streamLoaded = true;
            this.streamMediaTimeout = setTimeout(() => {
              if (video.readyState < 2) failStream();
            }, 20000);
          } catch {
            if (this.isConnected) failStream();
          } finally {
            clearTimeout(timeout);
            streamLoading = false;
          }
        };
        if (video) {
          video.addEventListener('loadeddata', () => {
            clearTimeout(this.streamMediaTimeout);
            streamStatus.hidden = true;
          });
          video.addEventListener('error', failStream);
          retry.addEventListener('click', loadStream);
          this.streamObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) loadStream();
              else video.pause();
            });
          }, { threshold: 0.1 });
          this.streamObserver.observe(video);
        }
        const activate = (tab) => {
          tabs.forEach((item) => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
            const panel = this.querySelector(`#${item.getAttribute('aria-controls')}`);
            if (panel) {
              panel.hidden = !selected;
              if (!selected && panel.contains(video)) video.pause();
            }
          });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', (event) => {
            const offsets = { ArrowRight: 1, ArrowLeft: -1 };
            let next;
            if (event.key in offsets) next = (index + offsets[event.key] + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(tabs[next]);
            tabs[next].focus();
          });
        });
        const requestedProject = new URLSearchParams(window.location.search).get('project');
        const projectSelect = this.querySelector('[data-project-type]');
        if (requestedProject && projectSelect && [...projectSelect.options].some((option) => option.value === requestedProject)) projectSelect.value = requestedProject;
        this.querySelectorAll('[data-project-choice]').forEach((link) => {
          link.addEventListener('click', () => {
            const select = this.querySelector('[data-project-type]');
            if (select) select.value = link.dataset.projectChoice;
          });
        });
      }
      disconnectedCallback() {
        this.streamObserver?.disconnect();
        this.streamController?.abort();
        clearTimeout(this.streamMediaTimeout);
        this.querySelector('[data-river-video]')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
